import { takeEvery, select, put, call, take, race, all, fork } from "redux-saga/effects";
import * as NotificationsStore from "../notificationsStore";
import * as notificationsApi from "../../api/notificationsApi";

export function* watchNotificationsSagas() {
    yield takeEvery(NotificationsStore.ActionType.CreateNotification, createNewNotification);
    yield takeEvery(NotificationsStore.ActionType.RequestUnreadNotifications, fetchNewestNotification);
    yield takeEvery(NotificationsStore.ActionType.SetNotificationRead, setNotificationRead);
}

function* createNewNotification(action: NotificationsStore.CreateNotification) {
    const result = yield call(notificationsApi.addNotification, action.notification);
}

function* fetchNewestNotification() {
    const notifications = yield call(notificationsApi.fetchNewestNotification);
}

function* setNotificationRead(action: NotificationsStore.SetNotificationRead) {
    yield call(notificationsApi.setNotificationRead, action.id);
}


// WEBPACK FOOTER //
// ./src/notifications/store/sagas.ts